import React from "react";
import { Link } from "react-router-dom";
import { servicesLabels } from "../../Utils/data";

const Header = () => {
  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">
          <img src="./assets/logo.png" alt="logo" width="100" />
        </Link>
      </div>
      <ul className="nav-links">
        <input type="checkbox" id="checkbox_toggle" />
        <label for="checkbox_toggle" className="hamburger">
          &#9776;
        </label>
        <div className="menu">
          <li className="menu-items">
            <Link to="/">Home</Link>
          </li>
          <li className="menu-items">
            <Link to="/about">About Us</Link>
          </li>
          <li className="services menu-items">
            <Link to="/services">
              Services <span className="service-icon">&#8964;</span>
            </Link>
            <ul className="dropdown">
              <li>
                <span className="dropdown-heading caption">Core Services</span>
              </li>
              {servicesLabels?.map((nav) => (
                <>
                  {" "}
                  {!!nav?.serviceName?.includes("Imaging") && (
                    <>
                      <div className="bottom-line"></div>
                      <li>
                        <span className="dropdown-heading caption">
                          Other Services
                        </span>
                      </li>
                    </>
                  )}{" "}
                  <li className="typography0">
                    <Link to={nav?.url + nav?.id}>{nav?.serviceName} </Link>
                  </li>
                </>
              ))}
            </ul>
          </li>
          <li className="menu-items">
            <Link to="/memberships">MEMBERSHIPS</Link>
          </li>
          <li className="menu-items">
            <Link to="/resources">Resources</Link>
          </li>
          <li className="menu-items">
            <Link to="/testimonials">Testimonials</Link>
          </li>
          <li className="menu-items inline-block">
            <Link to="/contactUs">Contact US</Link>
          </li>
        </div>
      </ul>
    </nav>
  );
};

export default Header;
